export function getAvailableViewportHeight(): number {
  const docH = document.documentElement.clientHeight || window.innerHeight || 0
  const header = document.querySelector('header')
  const footer = document.querySelector('footer')
  const headerH = header ? Math.round((header as HTMLElement).getBoundingClientRect().height) : 0
  const footerH = footer ? Math.round((footer as HTMLElement).getBoundingClientRect().height) : 0
  return Math.max(0, docH - headerH - footerH)
}
